import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ButtonModule, MenuModule, RemoteAutocompleteModule } from '@sag-ui';
import { UserState } from '../../../user-management/state/user-management.state';
import { QueryUsers } from '../../../user-management/state/user-management.action';
import { debounceTime, Observable, tap } from 'rxjs';
import { Store } from '@ngxs/store';
import { IUser } from '@cod-monorepo/interfaces';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputModule } from '@sag-ui';

@Component({
    selector: 'app-table-user-filter',
    standalone: true,
    imports: [
        CommonModule,
        ButtonModule,
        MenuModule,
        RemoteAutocompleteModule,
        ReactiveFormsModule,
        FormsModule,
        InputModule
    ],
    templateUrl: './table-user-filter.component.html'
})
export class TableUserFilterComponent implements OnInit {
    @Input() label: string;
    @Input() selected: string[];
    @Output() selectionChange: EventEmitter<string[]> = new EventEmitter();

    protected readonly users: Observable<{ value: IUser; label: string }[]> = inject(Store).select(
        UserState.searchedUsers
    );
    protected selectControl = new FormControl(null);

    public compareFn = (firstUser: IUser | null, secondUser: IUser | null): boolean =>
        !!firstUser && !!secondUser && firstUser.gid === secondUser.gid;

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.initValues();
        this.initSearch();
    }

    public searchFn(search: string, page: number): Observable<void> {
        return this.store.dispatch(new QueryUsers(search, page));
    }

    private initSearch(): void {
        this.selectControl.valueChanges
            .pipe(
                debounceTime(200),
                tap(value => this.store.dispatch(new QueryUsers(value ?? '', 0)))
            )
            .subscribe();
    }

    private initValues(): void {
        this.store.dispatch(new QueryUsers('', 0));
    }

    public select(value: string): void {
        if (this.selected.includes(value)) {
            this.selectionChange.emit(this.selected.filter(v => v !== value));
        } else {
            this.selectionChange.emit([...this.selected, value]);
        }
    }
}
